import React, { Component } from 'react';
import { Modal, message, InputNumber } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class CoefficientConfig extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
    }

    show = () => {
        const { evaluateRecordId } = this.props;
        if (!evaluateRecordId) return;
        this.setState({ visible: true, loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryTreatGroupCoefficients,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const datas = (res.datas || []).map(item => ({ ...item, editStatus: false }));
                this.setState({ data: datas, loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    close = () => {
        this.setState({ visible: false, data: [], loading: false });
    }

    handleEdit = index => {
        const { data } = this.state;
        data[index].editStatus = true;
        this.setState({ data });
    }

    handleChange = (value, key, index) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({ data });
    }

    handleSave = index => {
        const { data } = this.state;
        const item = data[index];
        if (item.administrationCoefficient == null || item.administrationCoefficient === '') {
            message.warning('请输入给药系数（静脉系数）');
            return;
        }
        if (item.difficultyCoefficient == null || item.difficultyCoefficient === '') {
            message.warning('请输入难度系数（访视工时）');
            return;
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.saveTreatGroupCoefficients,
            data: {
                evaluateRecordCalculateTreatGroupId: item.evaluateRecordCalculateTreatGroupId,
                administrationCoefficient: item.administrationCoefficient,
                difficultyCoefficient: item.difficultyCoefficient,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '操作成功');
                data[index].editStatus = false;
                this.setState({ data });
            },
        });
    }

    getColumns = () => {
        const { record, type } = this.props;
        const { talAuth, deptBoAuth } = record;
        const canEdit = type !== 'view' && (talAuth || deptBoAuth);
        const columns = [{
            title: '访视方案',
            dataIndex: 'visitGroupingName',
            key: 'visitGroupingName',
            width: 200,
        }, {
            title: '静脉数',
            dataIndex: 'veinNum',
            key: 'veinNum',
            width: 80,
        }, {
            title: '给药系数（静脉系数）',
            dataIndex: 'administrationCoefficient',
            key: 'administrationCoefficient',
            width: 140,
            render: (text, record, index) => {
                if (!record.editStatus) return text;
                return <InputNumber
                    placeholder="请输入"
                    style={{ width: 100 }}
                    value={text}
                    min={0.01}
                    step={0.01}
                    precision={2}
                    onChange={value => this.handleChange(value, 'administrationCoefficient', index)}
                />;
            },
        }, {
            title: '难度系数（访视工时）',
            dataIndex: 'difficultyCoefficient',
            key: 'difficultyCoefficient',
            width: 140,
            render: (text, record, index) => {
                if (!record.editStatus) return text;
                return <InputNumber
                    placeholder="请输入"
                    style={{ width: 100 }}
                    value={text}
                    min={0.01}
                    step={0.01}
                    precision={2}
                    onChange={value => this.handleChange(value, 'difficultyCoefficient', index)}
                />;
            },
        }];
        if (canEdit) {
            columns.push({
                title: '操作',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    if (record.editStatus) {
                        return <a style={{ color: '#108ee9' }} onClick={() => this.handleSave(index)}>保存</a>;
                    }
                    return <a style={{ color: '#108ee9' }} onClick={() => this.handleEdit(index)}>修改</a>;
                },
            });
        }
        return columns;
    }

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="方案系数设置"
                visible={visible}
                onCancel={this.close}
                footer={null}
                width={800}
                style={{ top: '30%' }}
            >
                <TableC
                    data={data}
                    columns={this.getColumns()}
                    loading={loading}
                    rowKey="evaluateRecordCalculateTreatGroupId"
                    scrollY={400}
                />
            </Modal>
        );
    }
}

export default CoefficientConfig;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitPeriodPlan/components/CoefficientConfig.js